import { FileReference } from "Domain/Model/FileReference/FileReference";

export const CREATE_FILE_REFERENCE_SUCCESS = 'CREATE_FILE_REFERENCE_SUCCESS';

export const createFileReferenceSuccess = (payload: Record<string, FileReference> ) => ({
    type: CREATE_FILE_REFERENCE_SUCCESS,
    payload,
});
